import { demoFile, component, story, CLICK, variant, componentWithVariants } from "system/demo";
import { TopicChooserAdminScreen, TopicPhotoTeaser, TopicPhotoTeaserForArticle, TopicPhotoTeaserForTopic } from 'feature/teaser/topic-photo-teaser';
import { TopicTeaser } from "structure/topic";
import { ParamContext } from "util/params";

demoFile('feature/teaser/topic-photo-teaser');

const imageUrl = 'https://talkb.org/images/climate.png';

// Topic Photo Teaser
componentWithVariants('TopicPhotoTeaser', TopicPhotoTeaser, {}, [
    variant(null, {
        args: {
            topicKey: 'climate',
            topicPhoto: imageUrl,
            topicName: 'Climate',
            entryUrl: imageUrl,
            entryTitle: 'This is fine',
            entryImage: 'https://talkb.org/images/climate.png'
        },
        state: {
            roles: ['Owner']
        }
    }, [
        story('Click', [
            CLICK('photo-teaser')
        ])
    ]),
    variant('With Beta Tag', {
        args: {
            topicKey: 'climate',
            topicPhoto: imageUrl,
            topicName: 'Climate',
            entryUrl: imageUrl,
            entryTitle: 'This is fine',
            entryImage: 'https://talkb.org/images/climate.png'
        },
        state: {
            modulePublic: {'isBeta': true}
        }
    })
]);

// Topic Photo Teaser for Article
component('TopicPhotoTeaserForArticle', TopicPhotoTeaserForArticle, {
    state: {
        globals: {articleInfo: {title: 'This is fine', image: imageUrl}},
        collections: {topic: [{key: 'climate', text: 'Climate', photoUrl: imageUrl}]}
    },
    instanceKey: 'article'
});

// Topic Photo Teaser for Topic
const TopicPhotoTeaserForTopicDemo = TopicTeaser;
component('TopicPhotoTeaserForTopic', TopicPhotoTeaserForTopicDemo, {
    state: {
        globals: {name: 'Climate', photoUrl: imageUrl},
        globalParams: {entryUrl: 'https://foo.com'}
    },
    instanceKey: 'climate',
    config: {
        teaser: TopicPhotoTeaserForTopic
    }
});

// Topic Chooser
component('TopicChooserAdminScreen', TopicChooserAdminScreen, {
    state: {
        modulePublic: {
            topic: {
                climate: {key: 'climate', name: 'Climate', photoUrl: imageUrl},
                godzilla: {key: 'godzilla', name: 'Godzilla', photoUrl: imageUrl},                
            }
        },
        roles: ['Editorial']
    }
}, [
    story('Select Topic', [
        CLICK('Climate')
    ])
]); 